import AccessoriesA from './components/AccessoriesA';
import Animation3D from './components/Animation3D';
import Animation2 from './components/Animation2';
import BannerB from './components/BannerB';
import BlackA from './components/BlackA';
import ListA2 from './components/ListA2';
import CompareA from './components/CompareA';
import FaqA from './components/FaqA';
import FooterTcA from './components/FooterTcA';
import ListA1 from './components/ListA1';
import ListB from './components/ListB';
import PageNavLeft, { Theme } from './components/PageNavLeft';
import SectionA3 from './components/SectionA3';
import SectionB from './components/SectionB';
import SectionC from './components/SectionC';
import SectionD from './components/SectionD';
import SectionE from './components/SectionE';
import WhatInBoxA from './components/WhatInBoxA';
import SectionCard from './components/SectionCard';
import { useLang } from '@/i18n';
import { useShoppingCart } from '../../useShoppingCart';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { useEffect, useState } from 'react';
import gtm from 'eco-design-reliance/gtm';
import { createPortal } from 'react-dom';

export default function JP_Product() {
    const { t } = useLang('theProduct.KSP');

    const [isClient, setIsClient] = useState(false);
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);

    const { Comp, handleAddCart } = useShoppingCart();
    const handleAddToCart = (card: any, list_name?: string) => {
        if (card?.inventory <= 0) {
            return;
        }

        const obj: ShopifyCartItemType = { ...card };
        const target = shoppingCarts.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
        if (target) {
            obj.quantity = target.quantity + (target?.quantity < target.inventory ? 1 : 0);
            setShoppingCarts([
                obj,
                ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            ]);
        } else {
            obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
            setShoppingCarts([obj, ...shoppingCarts]);
        }
        setVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            product_name: card?.name || card?.title,
            list_name: list_name || 'none',
            price: card?.discountPrice,
            tag: 'none',
            quantity: obj?.quantity,
            button_name: card?.buyText || '',
            __btn_type: 'common',
            __btn_id1: card.className2,
            __btn_id2: card.className2,
        });
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean) => {
        setShoppingCarts(carts);
        if (isClose) {
            setVisible(false);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);
    return (
        <div className="ecoflow-wave-3-page">
            <BannerB />
            <div className="range1">
                <ListA1 />
            </div>
            <SectionCard callbackCart={handleAddToCart} />
            <ListB />

            <SectionA3 />
            <div className="range2">
                <Animation2 />
            </div>
            <div className="range3">
                <SectionB />
            </div>
            <div className="range4">
                <FaqA />
            </div>
            <div className="range5">
                <BlackA />
            </div>
            <ListA2 />
            <div className="range6">
                <SectionD />
            </div>
            <SectionC />
            <SectionE />
            <Animation3D />
            <CompareA />
            <WhatInBoxA />
            <AccessoriesA callback={handleAddCart} />
            <FooterTcA />

            <PageNavLeft
                triggerElement=".ecoflow-wave-3-page"
                enterElement="#ListB"
                steps={[
                    { text: t('item1'), href: '#ListA1' },
                    { text: t('item2'), href: '#wave3-D' },
                    { text: t('item3'), href: '#SectionB' },
                    { text: t('item4'), href: '#FaqA' },
                    { text: t('item5'), href: '#BlackA' },
                    { text: t('item6'), href: '#SectionD' },
                ]}
                triggerElements={[
                    { selectors: '#ListA1', theme: Theme.black },
                    { selectors: '#sectionC1', theme: Theme.white },
                    { selectors: '#screen1', theme: Theme.black },
                    { selectors: '#FaqA', theme: Theme.black },
                    { selectors: '#BlackA', theme: Theme.white },
                    { selectors: '#ListA2', theme: Theme.white },
                    { selectors: '#SectionD', theme: Theme.black },
                ]}
            />
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}

            {Comp}
        </div>
    );
}
